import React from 'react'

const SuggestionCard = (prop) => {
  return (
    <div
      className={`text-center py-1 md:px-5 px-3 line-clamp-2 rounded-lg text-[11px] leading-[13px] font-semibold font-montserrat flex items-center ${
        prop.isResponse
          ? "bg-[#174ae4] text-white hover:bg-white hover:text-[#174ae4]"
          : "hover:bg-[#eff3ff]  text-[#1543cd]"
      } border-2 border-[#174ae4] flex`}
      style={{
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
      }}
    >
      {prop.suggestion}
    </div>
  );
}

export default SuggestionCard